import { render, staticRenderFns } from "./ai-pika-examples.vue?vue&type=template&id=baa42d2c&lang=pug&"
import script from "./ai-pika-examples.vue?vue&type=script&lang=js&"
export * from "./ai-pika-examples.vue?vue&type=script&lang=js&"
import style0 from "./ai-pika-examples.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports